// Actions offered for a membership status. Backend statuses: active | suspended | deceased | banned.
export const membershipStatusActions = (status) =>
  status === "active"
    ? [
        { target: "suspended", color: "warning" },
        { target: "banned", color: "error" },
      ]
    : status
      ? [{ target: "active", color: "primary" }]
      : [];
